import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api';
import Add from '../../../../media/add.png';
import Edit from '../../../../media/edit.png';
import Delete from '../../../../media/delete.png';
import User from '../../../../media/user.png';
import Search from '../../../../media/search.png';
import ActiveIcon from '../../../../media/active.png';
import InactiveIcon from '../../../../media/inactive.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import AdminSelect from './admin_select';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const DEFAULT_OPTION = { value: null, label: "Filtra per corso" };
  const DEFAULT_OPTION_2 = { value: null, label: "Filtra per ente" };
  const DEFAULT_OPTION_3 = { value: null, label: "Filtra per ruolo" };
  const DEFAULT_OPTION_4 = { value: null, label: "Stato utente" };

  const [selectedStatus, setSelectedStatus] = useState(DEFAULT_OPTION_4);

  const [selectedCourse, setSelectedCourse] = useState(DEFAULT_OPTION);

  const [selectedOrganization, setSelectedOrganization] = useState(DEFAULT_OPTION_2);

  const [selectedRole, setSelectedRole] = useState(DEFAULT_OPTION_3);

  const orgByAdminUser = React.useMemo(() => {
    const map = new Map();

    organizations.forEach(org => {
      if (org.admin_user) {
        map.set(org.admin_user, org);
      }
    });

    return map;
  }, [organizations]);

  const [selectedExportUsers, setSelectedExportUsers] = useState([]);

  const [exportMode, setExportMode] = useState("all");
  const [selectedOrgForExport, setSelectedOrgForExport] = useState(null);

  const toggleUserSelection = (user, e) => {
    

    if (e?.target?.closest("button")) return;

    setSelectedExportUsers(prev =>
      prev.includes(user.slug)
        ? prev.filter(s => s !== user.slug)
        : [...prev, user.slug]
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, organizationsRes] = await Promise.all([
          ApiService.getUsers(),
          ApiService.getOrganizations(),
        ]);

        setUsers(usersRes);
        setOrganizations(organizationsRes);

      } catch (err) {
        console.error("Errore:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const selectedOrgId = selectedOrganization?.value
    ? Number(selectedOrganization.value)
    : null;

  const normalizedSearch = search.trim().toLowerCase();

  const selectedCourseSlug = selectedCourse?.value;

  const getCourseStatus = (user) => {
    if (!selectedCourseSlug) return null;

    const course = user.courses?.find(c =>
      c.slug === selectedCourseSlug &&
      (!selectedOrgId || c.organization_id === selectedOrgId)
    );

    return course?.is_active ?? null;
  };


  const filteredUsers = users.filter(user => {
    const username = (user.username || "").toLowerCase();
    const email = (user.email || "").toLowerCase();
    const firstName = (user.first_name || "").toLowerCase();
    const lastName = (user.last_name || "").toLowerCase();
    const userOrgIds = user.organizations?.map(o => o.id) || [];
    const adminOrg = orgByAdminUser.get(user.id);

    const matchesSearch =
      username.includes(normalizedSearch) ||
      email.includes(normalizedSearch) ||
      firstName.includes(normalizedSearch) ||
      lastName.includes(normalizedSearch) ||
      `${firstName} ${lastName}`.includes(normalizedSearch);


    const matchesCourse =
      !selectedCourseSlug ||
      user.courses?.some(c =>
        c.slug === selectedCourseSlug &&
        (!selectedOrgId || c.organization_id === selectedOrgId)
      );

    const matchesOrganization =
      !selectedOrgId ||
      userOrgIds.includes(selectedOrgId) ||
      adminOrg?.id === selectedOrgId;

    const matchesRole =
      !selectedRole?.value ||
      (
        selectedRole.value === "org_admin" &&
        user.is_org_admin
      );

    const courseStatus = getCourseStatus(user);

    const matchesStatus =
      !selectedStatus?.value ||
      (selectedStatus.value === "active" && courseStatus === true) ||
      (selectedStatus.value === "inactive" && courseStatus === false);

    return (
      matchesSearch &&
      matchesCourse &&
      matchesOrganization &&
      matchesRole &&
      matchesStatus
    );
  });

  const handleDelete = async (slug) => {
    
    confirmToast({
            message: `Sei sicuro di voler eliminare questo utente?`,
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                await ApiService.deleteUser(slug);
                setUsers(prev => prev.filter(t => t.slug !== slug));
                toast.success(`Utente eliminato con successo`);
              } catch (err) {
                toast.error("Errore durante l'eliminazione");
                      
              }
            },
          });
  };


    const courseOptions = [
      DEFAULT_OPTION,

      ...Array.from(
        new Map(
          users
            .flatMap(u => u.courses || [])
            .map(c => [c.slug, c])
        ).values()
      ).map(c => ({
        value: c.slug,
        label: c.title
      }))
    ];

    const organizationOptions = [
      DEFAULT_OPTION_2,

    ...organizations.map(org => ({
      value: org.id,
      label: org.name
    }))
  ];

  const roleOptions = [
      DEFAULT_OPTION_3,
    {
      value: "org_admin",
      label: "Amministratore Ente"
    }
  ];

  const statusOptions = [
    DEFAULT_OPTION_4,
    {
      value: "active",
      label: "Utenti attivi",
    },
    {
      value: "inactive",
      label: "Utenti non attivi",
    },
  ];

  useEffect(() => {
    if (!selectedCourse?.value) {
      setSelectedStatus(DEFAULT_OPTION_4);
    }
  }, [selectedCourse]);


  const handleExport = async () => {
    if (selectedExportUsers.length === 0) return;

    if (exportMode === "org" && !selectedOrgForExport) {
      toast.error("Seleziona un'organizzazione");
      return;
    }

    try {
      const pdfBlob = await ApiService.exportUsersPdf({
        users: selectedExportUsers,
        mode: exportMode,
        organization: selectedOrgForExport?.value || null,
      });

      const url = window.URL.createObjectURL(new Blob([pdfBlob]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "export_utenti.pdf");

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      toast.error("Errore durante export PDF");
    }
  };

  const exportModeOptions = [
    { value: "all", label: "Esportazione completa" },
    { value: "org", label: "Per organizzazione" },
  ];

  useEffect(() => {
    setSelectedOrgForExport(null);
  }, [exportMode]);

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header"style={{marginBottom:'50px'}}>
        <h2><img src={User} alt="" className="section-image" /> Utenti Registrati</h2>
        <div className="search-zone">
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca Utente..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button
          className="create-button"
          onClick={() => navigate('crea')}
        >
          <img src={Add} alt="Aggiungi" className="button-image" />
        </button>
      </div>
      <div
        style={{display: "flex",gap: "15px",marginBottom: "20px",flexWrap: "wrap"}}
      >
        <AdminSelect
          options={courseOptions}
          value={selectedCourse}
          onChange={setSelectedCourse}
          isSearchable={false}
          width="250px"
        />

        <AdminSelect
          options={organizationOptions}
          value={selectedOrganization}
          onChange={setSelectedOrganization}
          isSearchable={false}
          width="250px"
        />

        <AdminSelect
          options={roleOptions}
          value={selectedRole}
          onChange={setSelectedRole}
          isSearchable={false}
          width="250px"
        />
        <div style={{border: '2px solid #e0e0e0', borderRadius: '14px', display:'flex', flexDirection: 'row', padding: '10px', marginTop: '-13px', gap: '10px'}}>
          <AdminSelect
              options={exportModeOptions}
              value={
                exportModeOptions.find(o => o.value === exportMode)
              }
              onChange={(opt) => setExportMode(opt.value)}
              width="250px"
              isDisabled={selectedExportUsers.length === 0}
            />

            {exportMode === "org" && (
              <AdminSelect
                options={organizationOptions}
                value={selectedOrgForExport}
                onChange={setSelectedOrgForExport}
                width="250px"
                isDisabled={selectedExportUsers.length === 0}
              />
            )}

            <button
              className={`create-button ${
                selectedExportUsers.length > 0 ? "active" : "disabled"
              }`}
              onClick={handleExport}
              disabled={selectedExportUsers.length === 0}
            >
              Esporta PDF
            </button>
        </div>

        

      </div>
      <div style={{marginBottom: '20px', maxWidth: '250px'}}>
      {selectedCourse?.value && (
          <AdminSelect
            options={statusOptions}
            value={selectedStatus}
            onChange={setSelectedStatus}
            isSearchable={false}
            width="250px"
          />
        )}
      </div>

      {loading ? (
        <p>Caricamento...</p>
      ) : filteredUsers.length === 0 ? (
        <p>Nessun Utente disponibile</p>
      ) : (
        <ul className="teacher-list">
          {filteredUsers.map((user) => (
            <li
              key={user.id}
              className={`teacher-card ${
                selectedExportUsers.includes(user.slug) ? "selected" : ""
              } ${user.is_org_admin ? "disabled" : ""}`}
              onClick={(e) => toggleUserSelection(user, e)}
              style={{ cursor: "pointer" }}
            >
              <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                {(() => {
                  const status = getCourseStatus(user);

                  if (status === null) return null;

                  return (
                    <img
                      src={status ? ActiveIcon : InactiveIcon}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                  );
                })()}
              </div>
              <div className="teacher-info">
                <strong>{user.username}</strong><br/>
                Email: <strong>{user.email}</strong><br/>
                Data registrazione: <strong>{new Date(user.date_joined).toLocaleDateString('it-IT')}</strong>
              </div>
              <div className="teacher-actions">
                <button
                  className="create-button"
                  onClick={() => navigate(`modifica/${user.slug}` , { state: { userName: user.username } })}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(user.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserList;